/* eslint-disable import/prefer-default-export */
export const REGISTRATION_STATUS = {
  verify_in_progress: 'verify_in_progress',
  verify_success: 'verify_success',
  verify_failed: 'verify_fail',
  verify_skipped: 'verify_skipped', // use in social account (LinkedIn)
};

export const AUTH_TYPES = {
  simple: 'simple',
  social: 'social',
};
